import { AlertDialog, Button } from '@economic/taco';
import { Trans } from '@lingui/macro';

interface CancelTrialDialogProps {
    onSubmit: () => void;
}

export default function CancelTrialDialog({ onSubmit }: CancelTrialDialogProps) {
    return (
        <AlertDialog>
            <AlertDialog.Trigger>
                <Button appearance="ghost">
                    <Trans>Cancel trial</Trans>
                </Button>
            </AlertDialog.Trigger>
            <AlertDialog.Content aria-label="Cancel trial">
                <AlertDialog.Title>
                    <Trans>Cancel trial?</Trans>
                </AlertDialog.Title>
                <p>
                    <Trans>Do you want to cancel your trial?</Trans>
                </p>
                <AlertDialog.Footer>
                    <AlertDialog.Cancel>
                        <Button>Cancel</Button>
                    </AlertDialog.Cancel>
                    <AlertDialog.Action>
                        <Button appearance="danger" onClick={onSubmit}>
                            <Trans>OK</Trans>
                        </Button>
                    </AlertDialog.Action>
                </AlertDialog.Footer>
            </AlertDialog.Content>
        </AlertDialog>
    );
}
